// Infrastructure / Supabase adapter
import { supabase } from "../../../../infra_/supabase/supabaseClient.js";

export const ventasxfacturaRepository = {
  async listar(filtros = {}) {
    let query = supabase
      .from("facturas")
      .select(`
        *,
        fecha_factura::text,
        ventas (
          *,
          detalle_ventas ( * )
        )
      `)
      .order("numero_factura", { ascending: false });

    if (filtros.estado) {
      query = query.eq("estado", filtros.estado);
    }

    if (filtros.numeroFactura) {
      query = query.eq("numero_factura", filtros.numeroFactura);
    }

    const { data, error } = await query;
    if (error) throw error;

    return data;
  },
};
